import {defineRule} from "vee-validate";
import { all } from '@vee-validate/rules';
import {object, string} from "yup";
Object.entries(all).forEach(([name, rule]) => {
  defineRule(name, rule);
});

defineRule('selector_object_required', (value, params, ctx) => {
  const fieldName = ctx?.label ?? ctx.field;

  try {
    object({
      name: string().required(`${fieldName} is required`),
    }).validateSync(value);
    return true;
  } catch (err){
    return err.errors[0];
  }
});


defineRule('required', (value, params, ctx) => {
  const fieldName = ctx?.label ?? ctx.field;

  try {
    string().required(`${fieldName} is required`).validateSync(value);
    return true;
  } catch (err){
    return err.errors[0];
  }
});

defineRule('min', (value, [len], ctx) => {
  const fieldName = ctx?.label ?? ctx.field;
  const message = `${fieldName} must be at least ${len} characters`;

  try {
    string().min(len, message).validateSync(value);
    return true;
  } catch (err){
    return err.errors[0];
  }
});

defineRule('max', (value, [len], ctx) => {
  const fieldName = ctx?.label ?? ctx.field;
  const message = `${fieldName} must be at most ${len} characters`;

  try {
    string().max(len, message).validateSync(value);
    return true;
  } catch (err){
    return err.errors[0];
  }
});

defineRule('email', (value, [len], ctx) => {
  const fieldName = ctx?.label ?? ctx.field;
  const message = `${fieldName} must be a valid email address`;

  try {
    string().email(message).validateSync(value);
    return true;
  } catch (err){
    return err.errors[0];
  }
});

defineRule('max_words', (value, [len], ctx) => {
  const fieldName = ctx?.label ?? ctx.field;
  let message = 'The ' + fieldName + ' should be less than ' + len + ' words';

  return value.trim().replace(/\s+/gi, ' ').split(' ').length <= len ? true : message;
});

defineRule('link', (value, [], ctx) => {

  // Can be empty
  if (value === '' || typeof value === 'undefined'){
    return true;
  }

  const fieldName = ctx?.label ?? ctx.field;

  let message = 'Invalid ' + fieldName;
  let regex = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
  let without_regex = new RegExp("^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");

  if(regex.test(value) || without_regex.test(value)){
    return true;
  } else{
    return message;
  }

})

defineRule('no_links', (value, [len], ctx) => {
  if (value === '' || typeof value === 'undefined'){
    return true;
  }

  const fieldName = ctx?.label ?? ctx.field;
  let message = 'The ' + fieldName + ' field should not contain links or email addresses';

  let emailReg = /[A-Z0-9._%+-]+@(?:[A-Z0-9-]+\.)+[A-Z]{2,}/gi;
  let urlReg = /(http|www|\.com|\.com\.au|\.net)/gi;

  //email test
  if (value.match(emailReg)) {
    return message;
  }

  if (value.match(urlReg)) {
    return message;
  }

  return true;
})

defineRule('no_capital_excess', (value, [len], ctx) => {
  if (value === '' || typeof value === 'undefined'){
    return true;
  }

  const fieldName = ctx?.label ?? ctx.field;
  let message = 'The ' + fieldName + ' is using excessive sequential capital letters';

  return (value.match(/[A-Z]{10,}/g) || []).length < 1 ? true : message;
});

defineRule('ata',  (value, [len], ctx)=> {
  let message = 'The ' + ctx.label + ' must match the following format TCWA-ASW-XX-XXXX';

  if (!value) {
    return message;
  }

  if (value === '') {
    return message;
  }

  if (typeof value !== 'string') {
    return message;
  }

  return (
    (value.match(/^TCWA-[A-Z]{3}-[0-9]{2}-[0-9]{4}$/g) || []).length === 1 ? true : message
  );
});
